<template>
	<div @click.stop>
		<img v-if="!hover && !this.drawer" class="headerImage" :style="size ? `width: ${size}px` : ''" :src="icon ? icon : require('@/assets/AI-Chat-24px.svg')" @click="toggleDrawer"/>
		<div v-if="hover && !this.drawer" class="mg-chat-hover">
			<v-btn class="imgButton" variant="text" @click="toggleDrawer" :style="'bottom: ' + bottomPos + ' !important;'">
				<img :src="icon ? icon : require('@/assets/ChatMgButton.png')" />
			</v-btn>
		</div>
		<transition>
			<div class="bg" v-if="this.drawer" @click="toggleDrawer" />
		</transition>
		<div class="drawer chatDrawer" :style="'height: ' + drawerHeight">
			<v-list-item style="text-align: center;" @click="toggleDrawer">
				<div class="divider"></div>
				<v-row>
					<v-col cols="2"/>
					<v-col>
						<p class="title">Chat MG</p>
					</v-col>
					<v-col cols="2">
						<div v-if="this.drawer" class="mg-circle-image-button"><v-icon icon="mdi-close"/></div>
					</v-col>
				</v-row>				
			</v-list-item>
			<v-divider></v-divider>
			<div class="messagesCanvas">
				<div v-for="m in messages" :key="m">
					<div :class="'message ' + m.direction">
						<img v-if="m.direction === 'in'" class="message-avatar" :src="require('@/assets/mg.png')" alt="MG" />
						<div class="message-content" v-html="formatMessage(applyMonetaryMask(m.body))"></div>
					</div>
				</div>
				<div v-if="typing">
					<div class="message in typingIndicator">
						<span class="typingDots">
							<span></span><span></span><span></span>
						</span>
					</div>
				</div>
				<div style="clear:both" ref="end"></div>
			</div>
			<div class="inputBar" @click="event => {event.stopPropagation()}">
				<div class="inputBarInner">
					<transition>
						<v-text-field
							v-model="message"
							class="chatInput"
							:class="{'chatInputShrink': message && message.trim() !== ''}"
							type="text"
							placeholder="Enter your message"
							@keypress="onKeyPress"
							hide-details
							@keyup.enter="sendMessage"
							variant="solo"
							:flat="true"
							single-line
							outlined
							rounded
							dense
							key="input"
						>
							<template #append-inner>
								<v-icon
									:class="'sendIcon'"
									@click="attach"
									style="font-size: 24px; margin-right: 10px; color: #8c8897"
								>mdi-paperclip</v-icon> 
								<v-icon
									:class="'sendIcon'"
									:color="message && message.trim() !== '' ? '#8c8897' : '#e2e0e8'"
									@click="message && message.trim() !== '' ? sendMessage() : null"
									style="cursor: pointer; font-size: 24px;"
								>mdi-send-outline</v-icon>
							</template>
						</v-text-field>
					</transition>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Services from '../../mixins/Services';
export default {
	name: "ChatMgHeaderButton",
	props: ['prompt', 'bottom', 'icon', 'hover', 'initialPrompt', 'size'],
	mixins: [Services],
	el: '#app',
	data() {
		return{
			drawer: false,
			drawerHeight: "0px",
			message: null,
			messages:[],
			typing: false,
			bottomPos: "19%",
			promptSent: true, // Disable initial prompt
			idleTimeout: 20000,
			inputIdleTimer: null,
			inputLastTouched: null,
			idlePromptShown: false,
			userHasTyped: false,
			prompts: ["Feel free to ask me anything, don't be shy 😊", 
				"What can I help you with today?", 
				"Ask away!",
				"How can I assist you today?",
				"What's on your mind today? 🧠",
				"I'm here to help with your financial questions. 🙋‍♀️",
				"Let's talk about your goals and how I can assist you.",
				"Let's talk finances. 💬",
				"Here to help with your financial journey. 🛤️",
				"I'm ready when you are. ✅",
				"You wait - time passes. ⏳",
				"How can I help you manage your money? 🤝",
				"Ask me anything about your finances. 🤔",
				"Your financial well-being is my priority. 💼",
				"Let's work together to achieve your financial goals."
			]
		}
	},
	methods: {
		toggleDrawer: function() {
			console.log('ChatMgButton toggleDrawer called', new Error().stack);
			this.drawer = !this.drawer;
			if (this.drawer) {
				document.body.classList.add('hide-nav-bar');
				this.drawerHeight = "90%";
				this.idlePromptShown = false; // Reset prompt flag on open
				this.userHasTyped = false; // Reset userHasTyped on open
				this.resetInputIdleTimer();
				console.log('prompt:', this.prompt);
				if (this.initialPrompt) {
					this.promptSent = false;
				}
				if (this.prompt && !this.promptSent) {
					console.log('Sending initial prompt:', this.prompt);
					this.promptSent = true;
					this.sendMessageAndWaitForResponse(this.prompt, false);
				}
			} else {
				document.body.classList.remove('hide-nav-bar');
				this.drawerHeight = "0px";
				if (this.inputIdleTimer) clearTimeout(this.inputIdleTimer);
			}
		},
		onKeyPress: function(event) {
			if (!this.userHasTyped && event.key.length === 1 && event.key.match(/\S/)) {
				this.userHasTyped = true;
			}
			if (event.key === "Enter") {
				if (!this.message || this.message.trim() === "") {
					event.preventDefault();
					return;
				}
				this.showSentMessage();
				this.sendMessageAndWaitForResponse(this.message);
				this.message = "";
				this.idlePromptShown = false; // Reset prompt flag on user interaction
			}
		},
		scrollToEnd() {
			this.$nextTick(() => {
				if (this.$refs["end"]) {
					this.$refs["end"].scrollIntoView({ behavior: 'smooth' });
				}
			});
		},
		showSentMessage: function() {
			this.messages.push({direction: "out", body: this.message});
			this.typing = true;
			this.scrollToEnd();
		},
		sendMessageAndWaitForResponse: function(message, store = true) {
			if (message.toLowerCase() == "litmustest")
			{
				this.$router.push('/litmustestpage');
				return;
			}
			if (message.toLowerCase() == "allownoti")
			{
				this._signalV1("enableNotifications", "", "", "", "activity");
				return;
			}
			if (message.toLowerCase() == "testpage")
			{
				this.$router.push('/test');
				return;
			}
			if (message.toLowerCase() == "hiddensettings")
			{
				let current = localStorage.getItem('showHiddenSettings') === 'true';
				localStorage.setItem('showHiddenSettings', (!current).toString());
				localStorage.setItem('useLocalCache', 'true');
				localStorage.setItem('useCachedEndpoints', 'true');
				this.$router.push('/');
				return;
			}
			if (message.toLowerCase() == "speak")
			{
				let current = localStorage.getItem('speak') === 'true';
				localStorage.setItem('speak', (!current).toString());
				return;
			}
			if (message.toLowerCase() == "payslips")
			{
				this.$router.push('/payslips');
				return;
			}
			if (message.toLowerCase() == "admin")
			{
				this.$router.push('/admin');
				return;
			}
			if (message.toLowerCase() == "chatpage")
			{
				this.$router.push('/chat');
				return;
			}

			this.typing = true;
			this._sendChatMessage(message, (res) => { 
				if (!res.keepThinking) {
					this.typing = false;
				}
				var messageIn = res.body.replaceAll("**", '');
				this.messages.push({direction: "in", body: messageIn, store: store});
				if (localStorage.getItem('speak') === 'true') { // this is in no WAY prod ready - just a quick implementation of the Web Speech API for fun, see where it goes
					const utterance = new SpeechSynthesisUtterance(messageIn);
					utterance.rate = 0.9;
					utterance.pitch = 0.8;
					utterance.voice = window.speechSynthesis.getVoices().find(voice => voice.lang === 'en-GB') || null;
					window.speechSynthesis.speak(utterance);
				}
				this.scrollToEnd();
			});
		},
		sendMessage() {
			if (this.message && !this.typing) {
				this.showSentMessage();
				this.sendMessageAndWaitForResponse(this.message);
				this.message = "";
				this.idlePromptShown = false; // Reset prompt flag on user interaction
				this.userHasTyped = true;
				this.resetInputIdleTimer();
			}
		},
		onLoad() {
			if (this.bottom) { this.bottomPos = this.bottom; }
			this.messages.push({direction: "in", body: "Please remember, the Digital Financial Assistant provides factual information to help you make informed decisions. " + 
				"Any specific actions it may suggest should be taken as guidance, and not advice."});
			this._getCustomer(() => {
			});
		},
		formatMessage(text) {
			if (!text) return '';
			// Convert markdown-style bold and italics
			let html = text
				.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
				.replace(/\*([^*]+)\*/g, '<em>$1</em>');
			// Convert markdown-style links
			html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
			// Convert numbered lists (remove extra <br> before numbers)
			html = html.replace(/(<br>)+\s*(\d+\.) /g, '<br>$2 ');
			// Convert bullet lists
			html = html.replace(/\n\s*- /g, '<br>&bull; ');
			// Convert newlines to <br>
			html = html.replace(/\n/g, '<br>');
			return html;
		},
		applyMonetaryMask(text) {
			if (localStorage.getItem('randomiseFigures') === 'true' && this._processMonetaryAmounts) {
				return this._processMonetaryAmounts(text);
			}
		return text;
		},
		resetInputIdleTimer() {
			if (this.inputIdleTimer) clearTimeout(this.inputIdleTimer);
			// Only allow the prompt once per drawer open and only if user has never typed
			if (this.idlePromptShown || this.userHasTyped) return;
			this.inputIdleTimer = setTimeout(() => {
				if (!this.typing && (!this.message || this.message.trim() === '') && !this.idlePromptShown && this.drawer && !this.userHasTyped) {
					this.typing = true;
					setTimeout(() => {
						this.typing = false;
						this.messages.push({direction: "in", body: this.prompts[Math.floor(Math.random() * this.prompts.length)]});
						this.idlePromptShown = true;
						this.scrollToEnd();
					}, 2000);
				}
			}, this.idleTimeout);
		},
		attach() {
			if (this.customer) {
				if (this.customer.person.whatsAppEnabled) {
					this.messages.push({direction: "in", body: "Check your WhatsApp!"});
					this.scrollToEnd();
					this._sendWhatsAppNotification("You indicated you wanted to send a document 📄  Just drop it here and we will upload and process it for you 👍", this.customer.person.mobilePhone);	
				} else {
					this.$router.push('/#/enablewhatsapp');
				}
			}
		},
	},
	mounted: function() { 
		this.onLoad();
		this.$watch('message', () => {
			this.resetInputIdleTimer();
		});
	}
}
</script>

<style scoped>

	.headerImage {
		width: 100%;
		height: 100%;
		position: relative;
		z-index: 10000;
		cursor: pointer;
		object-fit: contain;
	}

	.title{
		font-weight: bold;
	}

	.divider {
		width: 48px;
		margin-bottom: 8px;
		margin-top: 8px;
		margin-right: auto;
		margin-left: auto;
		background: var(--Keyline, rgba(51, 40, 71, 0.10));
		height: 4px;
		border-radius: 4px;
	}

	.drawer {
		border-radius: 16px 16px 0px 0px;
		border: 0px;
		overflow-y: hidden;
		background-color: var(--background-color);
		position: fixed;
		bottom: -20px;
		width: 100%;
		left: 0px;
		transition: all .3s ease-out;
		z-index: 1101 !important;
	}

	.chatInput {
		flex: 1 1 auto;
		min-width: 0;
		margin: 0 8px;
		transition: width 0.25s cubic-bezier(0.4,0,0.2,1), flex-basis 0.25s cubic-bezier(0.4,0,0.2,1);
		width: 100%;
		flex-basis: 100%;
	}
	.chatInputShrink {
		width: calc(100% - 48px);
		flex-basis: calc(100% - 48px);
	}

	.in 
	{
		float: left;
		text-align: left;
		background: #F9F7F3 !important;
	}
	
	.out
	{
		float: right;
		text-align: left;
		background: #E2E4F2 !important;
	}

	.message {
		background: linear-gradient(358.65deg, #F7F4F0 0.56%, #FAF8F5 101.36%);
		color: var(--text-color);
		font-size: 16px;
		padding: 16px;
		border-radius: 15px;
		width: 75%;
		margin-bottom: 20px;
		clear:both;
		word-break: break-word;
		overflow-wrap: anywhere;
		position: relative;
	}

	.message.in {
		margin-left: 30px;
	}

	.message-avatar {
		position: absolute;
		bottom: 0px;
		left: -40px;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		border: 2px solid white;
		box-shadow: 0 2px 4px rgba(0,0,0,0.1);
	}

	.message-content {
		margin-left: 0;
	}

	.messagesCanvas {
		height: calc(100% - 110px);
		overflow-y: scroll;
		padding: 20px;
		padding-bottom: 80px; 
	}

	.bg {
		z-index: 1100 !important;
		position: fixed;
		width: 100vw;
		height: 100vh;
		top: 0px;
		left: 0px;
		background-color: #332847b5;
	}

	.typingIndicator {
		background: #ececec;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		width: 60px;
		height: 32px;
		border-radius: 18px;
		padding: 6px 12px;
		margin-bottom: 10px;
		box-shadow: 0 1px 2px rgba(0,0,0,0.04);
	}
	.typingDots {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		width: 100%;
	}
	.typingDots span {
		display: inline-block;
		width: 8px;
		height: 8px;
		margin: 0 2px;
		background: #bdbdbd;
		border-radius: 50%;
		opacity: 0.7;
		animation: typing-bounce 1.2s infinite both;
	}
	.typingDots span:nth-child(2) {
		animation-delay: 0.2s;
	}
	.typingDots span:nth-child(3) {
		animation-delay: 0.4s;
	}
	@keyframes typing-bounce {
		0%, 80%, 100% { transform: scale(0.7); opacity: 0.7; }
		40% { transform: scale(1); opacity: 1; }
	}

	.inputBar {
		position: absolute;
		bottom: 34px;
		left: 5px;
		width: 100%;
		background: var(--background-color);
		padding: 12px 0 12px 0;
		z-index: 1020;
	}

	.inputBarInner {
		display: flex;
		align-items: center;
		gap: 0;
		padding: 0 8px 0 0;
	}
	.sendBtn {
		width: 40px;
		height: 40px;
		min-width: 0;
		min-height: 0;
		margin-top: 5px;
		color: var(--background-color-alt3);
		align-self: stretch;
		display: flex;
		align-items: center;
		justify-content: center;
		background: var(--background-color-alt3) !important;
	}
	.sendBtn .v-icon {
		margin-top: 0px;
		color: var(--text-color) !important;
	}

	.v-text-field ::v-deep(.v-field) 
	{
		border: 1px solid #413655 !important;
		border-radius: 12px !important;
	}

	.sendIcon {
		transition: opacity 0.2s;
	}

	.mg-chat-hover {
		position: fixed !important;
		bottom: 0 !important;
		right: 0 !important;
		z-index: 0 !important;
	}

	.imgButton {
		position: fixed !important;
		right: 20px !important;
		z-index: 99999 !important;
		height: 80px !important;
		width: 80px !important;
		border-radius: 50% !important;
	}
	
	.imgButton img {
		height: 80px !important;
		width: 80px !important;
		border-radius: 50% !important;
	}
</style>
